import { GlobalService } from '../../core/services/global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NotifierService, NotifierMessageType } from '../../core';
import { Headers } from '@angular/http';

@Injectable()
export class ImportService {

    constructor(private http: GlobalService, private notifierService: NotifierService) {
    }

    importDrivers(file: File): Observable<string> {
        const url = `import/importDrivers`;

        const formData: FormData = new FormData();
        formData.append('File', file, file.name);
        const headers = new Headers();

        return this.http.postFile(url, formData, headers)
            .map(response => {
                this.notifierService.activateSimple(NotifierMessageType.Success, response.payload.text());
            })
            .catch((error: any) =>
                Observable.throw(this.errorHandler(error)));
    }

    getGenericImportDriverTemplate(): Observable<any> {
        const url = `import/importTemplateDrivers`;

        const headers = new Headers();
        headers.append('Content-Type', 'application/vnd.ms-excel');
        headers.append('responseType', 'arrayBuffer');

        return this.http.file(url, null, headers)
            .map(x => {
                const blob = new Blob([x.payload.blob()], { type: 'application/vnd.ms-excel' });

                window['saveAs'](blob, 'Template Conductores.xlsx');
            });
    }

    errorHandler(error: any): void {
        this.notifierService.activateSimple(NotifierMessageType.Error, error.payload._body);
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/import.service.ts